import React, { useEffect, useRef, useState } from "react";
import LoadingIcon from "components/LoadingIcon/LoadingIcon";

// Custom Components
import Filter from "components/Filter";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { fetchDataFromApi } from "utils";
import { Card, CardContent, Divider } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";

import CardHeader from "components/Card/CardHeader";
import CardFooter from "components/Card/CardFooter";
import { BO_MODULE_ACCESS_URL } from "configs/constants";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { useNotifyContext } from "@Components/Notify";


const filterFields = [

    {
        type: "datepicker",
        label: "User Access Date",
        name: "date",
        maxDate: new Date(),
    },
];


const today = new Date();
today.setDate(today.getDate() - 1);
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let date = today.toLocaleDateString('en-GB', options);
date = date.split('/').reverse().join('-');

const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            func();
        } else {
            didMount.current = true;
        }
    }, deps);
};

export default function boAccessReportMobileApp() {

    const { t } = useTranslation();


    const [dateForAPI, setDateForAPI] = useState(date);
    const [dateForAPITotal, setDateForAPITotal] = useState(date);
    const [dateForAPIPercentage, setDateForAPIPercentage] = useState(date);
    const [summaryPercentage, setSummaryPercentage] = useState({});
    const [percentageAccessLoading, setPercentageAccessLoading] = useState(false);
    const [totalAccessLoading, setTotalAccessLoading] = useState(false);
    const [summary, setSummary] = useState({});
    const [total, setTotal] = useState({});
    const [totalTable, setTotalTable] = useState({});

    const filterInitialValues = {
        date: date,
    };
    const setNotify = useNotifyContext();

    const useStyles = makeStyles({
        borderedCell: {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
            backgroundColor: "#fff2cc",
        },
        bodyCell: {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
        },
    });
    const classes = useStyles();

    const apiCallback = (data) => {
        let results = {};
        let total = {};

        if (data) {
            if (Array.isArray(data.by_company)) {
                results["total"] = data.by_company;
                setTotalAccessLoading(false);
                setPercentageAccessLoading(false);
                total = data.total;
            } else {
                results["total"] = [];
            }
        }

        setTotal({ ...total });
        setSummary({ ...summary, ...results });
    };


    useDidMountEffect(() => {
        setTotalAccessLoading(true);
        fetchDataFromApi(
            BO_MODULE_ACCESS_URL + "?date=" + dateForAPI,
            apiCallback,
            false, {},
            apiCallbackForError
        );
    }, [dateForAPI]);


    useDidMountEffect(() => {
        fetchDataFromApi(
            BO_MODULE_ACCESS_URL + "?date=" + dateForAPITotal,
            apiCallbackForTotal,
            false,
            {},
            apiCallbackForError
        )
    }, [dateForAPITotal]);

    useDidMountEffect(() => {
        fetchDataFromApi(
            BO_MODULE_ACCESS_URL + "?date=" + dateForAPIPercentage,
            apiCallbackForPercentage,
            false, {},
            apiCallbackForError
        )

    }, [dateForAPIPercentage]);

    const apiCallbackForError = (error) => {
        setNotify({
            isOpen: true,
            message: (error.response && error.response.data && error.response.data.message) || 'Error occurred',
            type: "error",
        });
        setTotalAccessLoading(false);
        setPercentageAccessLoading(false);
    };

    const apiCallbackForTotal = (data) => {
        let results = {};
        let total = {};

        if (data) {
            if (Array.isArray(data.by_company)) {
                results["total"] = data.by_company;
                setTotalAccessLoading(false);
                total = data.total;
            } else {
                results["total"] = [];
            }
        }

        setTotal({ ...total });
        setSummary({ ...summary, ...results });
    };

    const apiCallbackForPercentage = (data) => {
        let results = {};
        let total = {};

        if (data) {
            if (Array.isArray(data.by_company)) {
                results["total"] = data.by_company;
                setPercentageAccessLoading(false);
                total = data.total;
            } else {
                results["total"] = [];
            }
        }

        setTotalTable({ ...total });
        setSummaryPercentage({ ...summaryPercentage, ...results });
    };

    useEffect(() => {
        fetchDataFromApi(
            BO_MODULE_ACCESS_URL + "?date=" + dateForAPITotal,
            apiCallbackForTotal,
            false,
            {},
            apiCallbackForError
        );
        fetchDataFromApi(
            BO_MODULE_ACCESS_URL + "?date=" + dateForAPIPercentage,
            apiCallbackForPercentage,
            false,
            {},
            apiCallbackForError
        );
    }, []);


    const handleSubmitTotal = (values) => {
        setTotalAccessLoading(true);
        setDateForAPITotal(values.date);

        setTimeout(() => {
            setTotalAccessLoading(false);
        }, 1000);
    };

    const handleSubmitPercentage = (values) => {
        setPercentageAccessLoading(true);
        setDateForAPIPercentage(values.date);

        setTimeout(() => {
            setPercentageAccessLoading(false);
        }, 1000);
    };






    return (
        <div>
            <div>
                <Filter
                    noClearButton
                    initialValues={filterInitialValues}
                    filterFields={filterFields}
                    onSubmit={handleSubmitTotal}

                />
                {summary.total ? (
                    <div>

                        <br />
                        {totalAccessLoading ? (
                            <LoadingIcon text="Loading" />
                        ) : (
                            <Paper
                                className={classes.filterPaper}
                                variant="outlined"
                                style={{ padding: "20px" }}
                            >
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Typography paragraph variant="h5" color="textPrimary">
                                        {" " + t("BACKOFFICE USER ACCESS TO ")}
                                        <span style={{ color: 'red' }}>MOBILE APP</span>
                                        {" " + t("SUMMARY (TOTAL)")}
                                    </Typography>
                                </div>
                                <Divider />
                                <Grid
                                    container
                                    spacing={1}
                                    alignItems="center"
                                    justify="flex-start"
                                    style={{ marginTop: 15 }}
                                    wrap="nowrap"

                                >
                                    {summary.total.map((sum, index) => {
                                        return (
                                            <Grid
                                                key={index}
                                                container
                                                justify="center"
                                                item
                                                xs={12}
                                                sm={6}
                                                md={6}
                                                lg={3}
                                            >

                                                <Card
                                                    value={sum}
                                                    style={{
                                                        borderRadius: "5px",
                                                        backgroundColor: "#fff2cc",
                                                        display: "block",
                                                        width: "200px",
                                                        textAlign: "center",
                                                    }}
                                                    className={classes.card}
                                                >
                                                    <CardHeader
                                                        title={t(sum.company.name)}

                                                        style={{
                                                            backgroundColor: "#fff2cc",
                                                            color: "black",
                                                            borderRadius: "5px px 0 0",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <div>
                                                            <Typography color="black">{sum.company?.name}</Typography>
                                                        </div>
                                                    </CardHeader>
                                                    <CardContent
                                                        style={{
                                                            backgroundColor: "#fff",
                                                            color: "black",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="h6" color="black" component="p">
                                                            {sum.accessed || 0}
                                                        </Typography>

                                                    </CardContent>

                                                </Card>

                                            </Grid>
                                        );
                                    })}
                                    {total != null ?
                                        <Grid
                                            key="totalvalue"
                                            container
                                            justify="center"
                                            item
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={3}
                                        >

                                            <Card
                                                value={total}
                                                style={{
                                                    borderRadius: "5px",
                                                    backgroundColor: "#fff2cc",
                                                    display: "block",
                                                    width: "200px",
                                                    textAlign: "center",
                                                }}
                                                className={classes.card}
                                            >
                                                <CardHeader
                                                    title="Total"

                                                    style={{
                                                        backgroundColor: "#dcecf3",
                                                        color: "black",
                                                        borderRadius: "5px px 0 0",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <Typography color="black">Total</Typography>
                                                    </div>
                                                </CardHeader>
                                                <CardContent
                                                    style={{
                                                        backgroundColor: "#fff",
                                                        color: "black",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <Typography variant="h6" color="black" component="p">
                                                        {total.accessed || 0}
                                                    </Typography>

                                                </CardContent>

                                            </Card>

                                        </Grid> : null
                                    }

                                </Grid>

                            </Paper>
                        )}
                    </div>

                ) : null}
                <br></br>
                <Filter
                            noClearButton
                            initialValues={filterInitialValues}
                            filterFields={filterFields}
                            onSubmit={handleSubmitPercentage}

                        />
                {summaryPercentage.total ? (
                    <div>
                       
                        <br />
                        {percentageAccessLoading ? (
                            <LoadingIcon text="Loading" />
                        ) : (
                            <Paper
                                className={classes.filterPaper}
                                variant="outlined"
                                style={{ padding: "20px" }}
                            >
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Typography paragraph variant="h5" color="textPrimary">
                                        {" " + t("BACKOFFICE USER ACCESS TO ")}
                                        <span style={{ color: 'red' }}>MOBILE APP</span>
                                        {" " + t("SUMMARY (%)")}
                                    </Typography>
                                </div>
                                <Divider />
                                <TableContainer component={Paper} style={{ marginTop: 15 }} >                                    <Table className={classes.table} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.borderedCell} >INFO</TableCell>
                                            {summaryPercentage.total.map((sum, index) => <TableCell className={classes.borderedCell} key={index}>{sum.company?.name}</TableCell>)}
                                            <TableCell className={classes.borderedCell} >GRAND TOTAL & PERCENTAGE (%)</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className={classes.bodyCell} >No. of Backoffice user access:</TableCell>
                                            {summaryPercentage.total.map((sum, index) => <TableCell className={classes.bodyCell} key={index}>{sum.accessed || 0}</TableCell>)}
                                            <TableCell className={classes.bodyCell} > {totalTable.accessed || 0}</TableCell>


                                        </TableRow>


                                        <TableRow>
                                            <TableCell className={classes.borderedCell}>Total Backoffice user active:</TableCell>
                                            {summaryPercentage.total.map((sum, index) => <TableCell className={classes.borderedCell} key={index}>{sum.active || 0}</TableCell>)}
                                            <TableCell className={classes.borderedCell} > {totalTable.active || 0}</TableCell>

                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.borderedCell}>Percentage (%):</TableCell>
                                            {summaryPercentage.total.map((sum, index) => (
                                                <TableCell className={classes.borderedCell} key={index}>
                                                    {(sum.percentage || 0) === 0 ? "0.00%" : sum.percentage.toFixed(2) + "%"}
                                                </TableCell>
                                            ))}
                                            <TableCell className={classes.borderedCell}>
                                                {(totalTable.percentage || 0) === 0 ? "0.00%" : totalTable.percentage.toFixed(2) + "%"}
                                            </TableCell>


                                        </TableRow>
                                    </TableBody>
                                </Table>
                                </TableContainer>

                            </Paper>
                        )}
                    </div>

                ) : null}

            </div>
        </div>
    );
}
